
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/page/[page]",
      function () {
        return require("private-next-pages/[lang]/page/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/page/[page]"])
      });
    }
  